module.exports = __webpack_public_path__ + "img/bud.b54de84b.png";